import React, {Fragment, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {useQuery} from "../utils/function-util";
import {WithOrganization} from "../components/organizations/organization-context";
import {Navigate, useNavigate, useParams} from "react-router-dom";
import {ProGroupEditor} from "../components/pro-guest/groups/edit-groups/ProGroupEditor";
import ReactsCard from "../components/ui/ReactsCard";
import {GoBackButton} from "../components/ui/GoBackButton";
import Button from "@material-ui/core/Button";
import {ArrowBackIos} from "@material-ui/icons";
import {FolderHierarchyBreadcrumbs} from "../components/pro-guest/shared/folder-hierarchy-breadcrumb/FolderHieararchyBreadcrums";

const useStyles = makeStyles(theme => ({
    root: {
        margin: theme.spacing(4),
        '& > *': {
            'margin-bottom': theme.spacing(4)
        }
    },
    top: {
        display: 'flex',
        flexDirection: 'row',
        flexGrow: 1,
        alignItems: 'center'
    },
    wizardCard: {
        minWidth: 250,
    },
    action: {
        justifyContent: 'flex-end'
    },
    table: {
        marginTop: '2rem',
        display: 'flex',
        justifyContent: 'center'
    }
}));


export const ProGroupWizard: React.FC<WithOrganization> = ({currentOrganization}) => {
    const query = useQuery();
    const folderId = query.get('folderId');
    const {groupId} = useParams<{groupId: string}>();
    const classes = useStyles();
    const [groupName, setGroupName] = useState('');
    const navigate = useNavigate();

    const goBack = () => {
        navigate(`/pro-guests?folderId=${folderId}&tabId=${1}`);
    };

    const getTitle =
        <Fragment>
            <GoBackButton goBack={goBack}/>
            {groupName}
        </Fragment>

    if (!folderId || !groupId) {
        const destination = groupId ?
             `/pro-guests/groups/${groupId}/edit?folderId=${folderId}`
            :`/pro-guests/`;
        return <Navigate to={destination} replace={false} />;
    }

    return <div className={classes.root}>
        <div className={classes.top}>
            <Button onClick={goBack}>
                <ArrowBackIos color="primary"/>
            </Button>
            <FolderHierarchyBreadcrumbs organizationId={currentOrganization.id}
                                        folderId={folderId}/>
        </div>
        <ReactsCard title={getTitle} className={classes.wizardCard}>
            <ProGroupEditor organizationId={currentOrganization.id} folderId={folderId} groupId={groupId}
                            onGroupNameChange={setGroupName} onClose={goBack}/>
        </ReactsCard>
    </div>
};

